import React from "react";
import { Layout } from "../../layouts/Layout";

const PrivacyPolicy = () => {
  return (
    <Layout title="Privacy Policy">
      <div className="container pt-120 pb-100">
        <div className="blog-details-content">
          <h2 className="title">Privacy Policy</h2>
          <p>Your privacy and trust are invaluable to us.</p>
          <p>
            Kadle Global Pvt Ltd collects limited data necessary to deliver an
            efficient and secure buying experience.
          </p>
          <ol>
            <li>
              <h5>Data Collected</h5>
              <p>We may collect:</p>
              <ul>
                <li>Name, address, contact details</li>
                <li>
                  Payment information (processed securely via PCI-DSS compliant
                  gateways such as Razorpay)
                </li>
                <li>Purchase and communication records</li>
              </ul>
            </li>
            <li>
              <h5>Purpose of Use</h5>
              <p>Data is used solely for:</p>
              <ul>
                <li>Order processing and shipping</li>
                <li>Customer support and service enhancement</li>
                <li>Legal or regulatory compliance</li>
              </ul>
              <p>
                We never sell, rent, or disclose customer data to unauthorized
                entities.
              </p>
            </li>
            <li>
              <h5>Third-Party Sharing</h5>
              <p>
                Data may be shared only with logistics, payment, and audit
                partners under strict confidentiality agreements.
              </p>
            </li>
            <li>
              <h5>Security & Retention</h5>
              <p>All customer information is stored securely.</p>
              <p>
                We use encryption, firewalls, and restricted access protocols to
                prevent misuse.
              </p>
            </li>
            <li>
              <h5>Legal Cooperation</h5>
              <p>
                In cases involving fraud, payment disputes, or misuse, we may
                cooperate with law enforcement authorities and share necessary
                data as required by law.
              </p>
            </li>
            <li>
              <h5>Your Rights</h5>
              <p>
                Customers may request access, correction, or deletion of their
                data by emailing{" "}
                <a href="mailto:hi@kadleglobal.com">hi@kadleglobal.com</a>.
              </p>
            </li>
          </ol>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;
